import * as React from 'react'

export function Methodology () {
  return (
    <aside className='ui blue secondary vertical segment' id='methodik'>
      <div className='ui text container'>
        <h2 className='ui infographic small grey header'>
          <i className='blue info circle icon' />
          <div className='content'>
            Wie <em>Tobi</em> arbeitet
          </div>
        </h2>

        <p>
          Basierend auf den Abstimmungsergebnissen für jede der 526 Zürcher und
          Berner Gemeinden werden individualisierte Texte aus Textbausteinen
          produziert.{' '}
        </p>
        <p>
          Wir setzen bei der Produktion der Inhalte auf das Tool Wordsmith von
          Automated Insights, einem Technologieunternehmen aus den USA, das auf
          Sprachgenerierungssoftware spezialisiert ist. Dieses Tool ermöglicht
          die automatische Wandlung von Daten in Texte. Die Nachrichtenagentur
          AP setzt es beispielsweise für automatisierte Quartalszahlenberichte
          von Firmen ein. Tamedia intern nennen wir dieses Tool <em>Tobi</em>.{' '}
        </p>
        <p>
          Wenn die Ergebnisse ermutigend sind und die Reaktionen der Leserinnen
          und Leser positiv ausfallen, können wir uns vorstellen, Tobi bei
          zukünftigen Abstimmungen oder sogar Wahlen einzusetzen.
        </p>
      </div>
    </aside>
  )
}



// WEBPACK FOOTER //
// ./src/components/methodology/index.js